/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoYandexZenIcon20Solid = forwardRef('LogoYandexZenIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M6 2a4 4 0 0 0-4 4v3.76c3.243-.04 5.066-.261 6.282-1.478C9.498 7.066 9.72 5.243 9.76 2H6Z" }),
        React.createElement("path", { d: "M10.24 2c.04 3.243.261 5.066 1.478 6.282C12.934 9.5 14.757 9.72 18 9.76V6a4 4 0 0 0-4-4h-3.76Z" }),
        React.createElement("path", { d: "M18 10.24c-3.243.04-5.066.261-6.282 1.478C10.5 12.934 10.28 14.757 10.239 18H14a4 4 0 0 0 4-4v-3.76Z" }),
        React.createElement("path", { d: "M9.76 18c-.04-3.243-.262-5.066-1.478-6.282C7.066 10.5 5.243 10.28 2 10.24V14a4 4 0 0 0 4 4h3.76Z" })));
});
